'use client'

import { useState } from 'react'

export default function Home() {
  const [points, setPoints] = useState([
    { x: '68.10', y: '23.70'},
    { x: '36.20', y: '36.90'},
    { x: '42.80', y: '70.00'},	 
    { x: '81.50', y: '70.30'},	 
    { x: '87.00', y: '51.60'},	 
    { x: '75.90', y: '51.90'},	 	 
  ])
  // const [points, setPoints] = useState([
  //   { x: `630.63`, y: '255.18' },
  //   { x: `619.03`, y: '221.24' },
  //   { x: `664.31`, y: '196.77' },
  //   { x: `672.93`, y: '195.16' },
  //   { x: `700.74`, y: '206.15' },
  //   { x: '699.65', y: '209.73' },
  //   { x: '677.47', y: '219.34' },
  //   { x: '679.81', y: '229.58' },
  //   { x: `662.36`, y: `243.05` }
  // ])
  const [result, setResult] = useState<any>(null);
  const [cirResult, setCirResult] = useState<any>(null);
  const [insideResult, setInsideResult] = useState<any>(null);
  const [avgDistanceResult, setAvgDestanceResult] = useState<any>(null);
  const [equalLoading, setEqualLoading] = useState(false);
  const [cirLoading, setCirLoading] = useState(false);
  const [insideLoading, setInsideLoading] = useState(false);
  const [avgLoading, setAvgLoading] = useState(false);
  const [error, setError] = useState(null);
  const [startPoint, setStartPoint] = useState("");
  const [endPoint, setEndPoint] = useState("");

  const addPoint = () => {
    setPoints([...points, { x: '', y: '' }])
  }

  const updatePoint = (index: number, field: 'x' | 'y', value: string) => {
    const updated = [...points]
    updated[index][field] = value
    setPoints(updated)
  }

  const sendToPython = async () => {
      setEqualLoading(true);
      setError(null);
      setResult(null);
    const coordinates = points
      .map(p => ({ x: parseFloat(p.x), y: parseFloat(p.y) }))
      .filter(p => !isNaN(p.x) && !isNaN(p.y))

    try {
      const res = await fetch(`${process.env.NEXT_PUBLIC_BACKEND_URL}/api/analysis/equal_area_calculate`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ coordinates }),
      })
      if (!res.ok) {
        const errorData = await res.json();
        throw new Error(errorData.error || 'サーバーエラーが発生しました。');
      }
      const data = await res.json()
      setResult(data)
    } catch (err) {
      console.error('接続エラー:', err)
    } finally {
      setEqualLoading(false)
    }
  }

  const calculateCircumscription = async () => {
    setCirLoading(true);
    setError(null);
    setCirResult(null);

    const coordinates = points
      .map(p => ({ x: parseFloat(p.y), y: parseFloat(p.x) }))
      .filter(p => !isNaN(p.x) && !isNaN(p.y));

    try {
      // エンドポイントを新しいものに変更
      const res = await fetch(`${process.env.NEXT_PUBLIC_BACKEND_URL}/api/analysis/circumscription_calculate`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ coordinates }),
      });

      if (!res.ok) {
        const errorData = await res.json();
        throw new Error(errorData.error || 'サーバーエラーが発生しました。');
      }

      const data = await res.json();
      setCirResult(data);
    } catch (err: any) {
      console.error('接続エラー:', err);
      setError(err.message);
    } finally {
      setCirLoading(false);
    }
  };

  const inscribedCalculate = async () => {
    setInsideLoading(true);
    setError(null);
    setInsideResult(null);

    const coordinates = points
      .map(p => ({ x: parseFloat(p.y), y: parseFloat(p.x) }))
      .filter(p => !isNaN(p.x) && !isNaN(p.y));

    try {
      // エンドポイントを新しいものに変更
      const res = await fetch(`${process.env.NEXT_PUBLIC_BACKEND_URL}/api/analysis/inscribed_calculate`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ coordinates }),
      });

      if (!res.ok) {
        const errorData = await res.json();
        throw new Error(errorData.error || 'サーバーエラーが発生しました。');
      }

      const data = await res.json();
      setInsideResult(data);
    } catch (err: any) {
      console.error('接続エラー:', err);
      setError(err.message);
    } finally {
      setInsideLoading(false);
    }
  };

  const averageDistanceCalculate = async () => {
    setAvgLoading(true)
    setError(null);
    setAvgDestanceResult(null);

    const coordinates = points
      .map(p => ({ x: parseFloat(p.y), y: parseFloat(p.x) }))
      .filter(p => !isNaN(p.x) && !isNaN(p.y));

    try {
      // エンドポイントを新しいものに変更
      const res = await fetch(`${process.env.NEXT_PUBLIC_BACKEND_URL}/api/analysis/average_distance_calculate`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ 
          coordinates, 
          startPoints: Number(startPoint), 
          endPoints: Number(endPoint) 
        }),
      });

      if (!res.ok) {
        const errorData = await res.json();
        throw new Error(errorData.error || 'サーバーエラーが発生しました。');
      }

      const data = await res.json();
      setAvgDestanceResult(data);
    } catch (err: any) {
      console.error('接続エラー:', err);
      setError(err.message);
    } finally {
      setAvgLoading(false);
    }
  };



  return (
    <main className="p-6 max-w-xl mx-auto bg-white text-black dark:bg-gray-900 dark:text-white min-h-screen">
      <h1 className="text-2xl font-bold mb-4">座標入力 → Pythonに送信</h1>

      {points.map((point, i) => (
        <div key={i} className="flex gap-2 mb-2 items-center">
          <span>No.{i}</span>
          <input
            type="number"
            placeholder="X"
            className="border p-1 w-1/2"
            value={point.x}
            onChange={e => updatePoint(i, 'x', e.target.value)}
          />
          <input
            type="number"
            placeholder="Y"
            className="border p-1 w-1/2"
            value={point.y}
            onChange={e => updatePoint(i, 'y', e.target.value)}
          />
        </div>
      ))}
      <div className='mb-5'>
        <span className='mr-2'>始点</span>
        <input 
          value={startPoint} 
          onChange={(e) => setStartPoint(e.target.value)} 
          className="border p-1 w-1/3 mr-5"
        />
        <span className='mr-2'>終点</span>
        <input 
          value={endPoint} 
          onChange={(e) => setEndPoint(e.target.value)} 
          className="border p-1 w-1/3"
        />
      </div>

      <button
        onClick={addPoint}
        className="px-4 py-1 bg-gray-300 rounded hover:bg-gray-400 mb-4"
      >
        ＋ 座標を追加
      </button>

      {/* <button
        onClick={sendToPython}
        className="px-6 py-2 bg-blue-500 text-white rounded hover:bg-blue-600 block mb-4"
      >
        {equalLoading ? '計算中...' : '等積矩形陰地法で計算を実行'}
      </button>
      <button
        onClick={calculateCircumscription}
        className="px-6 py-2 bg-blue-500 text-white rounded hover:bg-blue-600 block mb-4"
      >
        {cirLoading ? '計算中...' : '外接矩形法で計算を実行'}
      </button>
      <button
        onClick={inscribedCalculate}
        className="px-6 py-2 bg-blue-500 text-white rounded hover:bg-blue-600 block mb-4"
      >
        {insideLoading ? '計算中...' : '内接矩形法で計算を実行'}
      </button>
      <button
        onClick={averageDistanceCalculate}
        className="px-6 py-2 bg-blue-500 text-white rounded hover:bg-blue-600 block mb-4"
      >
        {avgLoading ? '計算中...' : '平均奥行計算を実行'}
      </button> */}

      {result && result.result && (
        <div>
          <h2>計算結果</h2>
          <ul>
            <li>図形の面積（㎡）: {result.result.polygon_area}</li>
            <li>長方形サイズ（幅×高さ）: {result.result.width} × {result.result.height}</li>
            <li>陰地面積（㎡）: {result.result.shadow_area}</li>
            <li>陰地割合（%）: {result.result.shadow_ratio}</li>
            <li>最適角度（°）: {result.result.angle}</li>
            <li>平行移動（X, Y）: ({result.result.offset_x}, {result.result.offset_y})</li>
            <li>アスペクト比（幅÷高さ）: {result.result.aspect_ratio}</li>
          </ul>
          
          {result.image && (
            <div>
              <h3>解析結果図</h3>
              <img src={`data:image/png;base64,${result.image}`} alt="解析結果" />
            </div>
          )}
        </div>
      )}

      {error && <p style={{ color: 'red' }}>エラー: {error}</p>}

      {cirResult && cirResult.result && (
        <div>
          <h2>計算結果（外接矩形陰地法）</h2>
          <ul>
            <li>図形の面積（㎡）: {cirResult.result.polygon_area}</li>
            <li>外接矩形面積（㎡）: {cirResult.result.circumscribed_area}</li>
            <li>矩形サイズ（幅×高さ）: {cirResult.result.width} × {cirResult.result.height}</li>
            <li>陰地面積（㎡）: {cirResult.result.shadow_area}</li>
            <li>陰地割合（%）: {cirResult.result.shadow_ratio}</li>
            <li>最適角度（°）: {cirResult.result.angle}</li>
          </ul>
          
          {cirResult.image && (
            <div>
              <h3>解析結果図</h3>
              <img src={`data:image/png;base64,${cirResult.image}`} alt="外接矩形法の解析結果" />
            </div>
          )}
        </div>
      )}

      {insideResult && insideResult.result && (
        <div>
          <h2>計算結果（内接矩形陰地法）</h2>
          <ul>
            <li>図形の面積（㎡）: {insideResult.result.polygon_area}</li>
            <li>内接矩形面積（㎡）: {insideResult.result.inscribed_area}</li>
            <li>矩形サイズ（幅×高さ）: {insideResult.result.width} × {insideResult.result.height}</li>
            <li>陰地面積（㎡）: {insideResult.result.shadow_area}</li>
            <li>陰地割合（%）: {insideResult.result.shadow_ratio}</li>
            <li>最適角度）: {insideResult.result.best_angle}</li>
          </ul>
          
          {insideResult.image && (
            <div>
              <h3>解析結果図</h3>
              <img src={`data:image/png;base64,${insideResult.image}`} alt="内接矩形法の解析結果" />
            </div>
          )}
        </div>
      )}
      {avgDistanceResult && avgDistanceResult.result && (
        <div>
          <h2>計算結果</h2>
          <ul className='text-center'>
            <li>図形の面積（㎡）: {avgDistanceResult.result.polygon_area}</li>
            <li>間口距離（㎡）: {avgDistanceResult.result.mouth_length}</li>
            <li>最大間口距離（㎡）: {avgDistanceResult.result.max_mouth_length}</li>
            <li>平均奥行（㎡）: {avgDistanceResult.result.average_depth}</li>
            <li>最大奥行（㎡）: {avgDistanceResult.result.max_depth}</li>
          </ul>
          
          {avgDistanceResult.image && (
            <div>
              <h3>解析結果図</h3>
              <img src={`data:image/png;base64,${avgDistanceResult.image}`} alt="内接矩形法の解析結果" />
            </div>
          )}
        </div>
      )}
    </main>
  )
}
